<template>
	<div class="sapphire-payment-portal" v-if="!!district.CWP_ALLOW_PAYMENTS_FLG && district.CWP_ALLOW_PAYMENTS_FLG === 'Y'">
		
		<div v-if="!!balance">
			<h3 style="margin-bottom:0px;">Balance: {{parseFloat(balance.BALANCE).toFixed(2) | dollar}}</h3>
			<p>
				<i>
					<small v-if="balance.MODIFIED_DATE !== ''">Last updated as of {{balance.MODIFIED_DATE | datetime('MMMM, DD YYYY HH:mm:ss', 'MM/DD/YYYY h:mm a') }}</small>
					<small v-else>last update not available</small>
				</i>
			</p>
		</div>
		
		<template v-if="paymentsAreAllowed && !userIsAdmin">
			<div v-if="studentHasSingleEnrollment || webstores.length === 1">
				<p><em>{{buildVancoWebstoreName(webstores[0])}}</em></p>
					<a
						target="_blank"
						:href="buildVancoWebstoreUrl(webstores[0])"
						style="cursor: pointer"
					>
						<img src="includes/images/RevTrakPay.svg" height="35" alt="RevTrak"/>
						<aria-new-tab-message :message="$t( 'MAIN_CONTENT.Accessibility.opensInNewTab' )" />
					</a>
			</div>
			<div v-else>
				<p><em>Choose Webstore</em></p>
				<button @click="setShowWebstoreModal(true)" style="cursor: pointer" class="btn-link" aria-label="Choose RevTrak Webstore"><img src="includes/images/RevTrakPay.svg" height="35" alt="RevTrak"/></button>
			</div>
		</template>
	</div>
</template>

<script>
	import { mapGetters, mapMutations } from 'vuex';
	import Modal from 'COMMONS/shared/Modal/Modal.vue';

	import Payments from '../api/Payments';
	import DistrictImage from '../api/DistrictImage';

	export default {
		props: {
			balance: {
				type:			Object,
				required:	true,
			}
		},
		components: {
			Modal,
		},
		data(){
			return {
				district: {},
				preferences: {},
			}
		},
		computed: {
			...mapGetters(['selectedStudent', 'roleRules', 'getShowWebstoreModal', 'userIsAdmin']),
			webstores(){
				let allWebstores = [];
				for( let i=0; i<this.selectedStudent.ENROLLMENT.length; i++){
					let school = this.selectedStudent.ENROLLMENT[i];
					if( (!!this.preferences.schools && !!this.preferences.schools[school.SCHOOL_ID]
							&& !!this.preferences.schools[school.SCHOOL_ID].WEBSTORE_URL
							&& !!this.preferences.schools[school.SCHOOL_ID].WEBSTORE_PROVIDER)
						){
						allWebstores.push(school.SCHOOL_ID);
					} else if( allWebstores.indexOf("DISTRICT") === -1) {
						allWebstores.push("DISTRICT");
					}
				}
				return allWebstores;
			},
			paymentsAreAllowed(){
				return !!this.roleRules && !!this.roleRules.FEES_ALLOW_PAYMENTS_FLG && this.roleRules.FEES_ALLOW_PAYMENTS_FLG === 'Y';
			},
			studentHasSingleEnrollment(){
				return this.selectedStudent.ENROLLMENT.length === 1
			},
		},
		methods:{
			...mapMutations(['setShowWebstoreModal']),
			closeWebstoreModal(){
				this.setShowWebstoreModal(false);
			},
			buildVancoWebstoreName(id){
				if( id === 'DISTRICT' ){
					return this.district.DISTRICT_DESC + ' Webstore';
				}

				if( !!this.preferences && !!this.preferences.schools[id] && !!this.preferences.schools[id].WEBSTORE_URL && !!this.preferences.schools[id].WEBSTORE_PROVIDER ){
					let school = this.selectedStudent.ENROLLMENT.find(e => {
						return e.SCHOOL_ID === id;
					})
					return school.SCHOOL_TITLE + ' Webstore';
				}

				return 'Webstore';
			},
			buildVancoWebstoreUrl(id){
				if( id === 'DISTRICT' ){
					return `https://${this.preferences.district.WEBSTORE_URL}/fee-management?provider=${this.preferences.district.WEBSTORE_PROVIDER}`;
				}

				if( !!this.preferences && !!this.preferences.schools[id] && !!this.preferences.schools[id].WEBSTORE_URL && !!this.preferences.schools[id].WEBSTORE_PROVIDER ){
					return `https://${this.preferences.schools[id].WEBSTORE_URL}/fee-management?provider=${this.preferences.schools[id].WEBSTORE_PROVIDER}`;
				}

				return '';
			},
			getDistrictImage() {
				const self = this;
				const district = new DistrictImage({});
				const promise = district.get();
				promise.then(response => {
					self.$set(self, 'district', district.getResponseData());
				});
			},
			getPreferences(){
				const self = this;
				let payment = new Payments({
					routeParams: {
						service: 'vanco',
						action: 'preferences',
					},
				});

				let paymentPromise = payment.get();
				paymentPromise.then(response =>{
					self.preferences = response.data.data;
				});

				return paymentPromise
			},
		},
		created(){
			this.getDistrictImage();
			this.getPreferences();
		}
	}
</script>

<style>
	.legal-footer p{
		line-height: 10px;
	}
	.legal-footer small {
		font-size: 8px;
	}
	.postal-code-input::-webkit-outer-spin-button,
	.postal-code-input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	.postal-code-input {
		-moz-appearance: textfield;
	}
	.sapphire-payment-portal{
		margin-bottom: 25px;
	}
	#payment-amount{
		margin-bottom: 50px;
	}
	#payment-form iframe {
		height: 20px !important;
	}
	#payment-amount #other-amount {
		width: 125px;
		border-radius: 6px;
		padding: 4px 6px;
	}
	.success-icon{
		font-size: 84px;
	}
	.cc-info-input{
		border: none;
		padding-top: 5px;
		padding-left: 0px;
		padding-right: 0px;
		box-shadow: none;
		font-size: 16px;
	}
	.cc-info-input::placeholder{
		color: #ccc;
	}
	.cc-info-input:focus{
		box-shadow: none;
	}

	.payment-processing-spinner{
		font-size: 64px;
		animation-name: spin;
		animation-duration: 3000ms;
		animation-iteration-count: infinite;
		animation-timing-function: linear;
		display: inline-block;
		color: #312852;
	}
	@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
	}

	.sapphire-payment-portal .modal-title{
		font-size: 1.6em;
		line-height: 1;
	}
	.sapphire-payment-portal .modal-title span{
		position: relative;
		top: 2px;
	}
	#payment-processing{
		margin-top: 25px;
		margin-bottom: 25px;
	}
	#payment-amount h2{
		margin-top: 10px;
	}
	.sapphire-payment-portal a{
		color: #604fa1;
	}
	.sapphire-payment-portal h2, .sapphire-payment-portal .modal-title, .sapphire-payment-portal .pay-through-vanco-btn{
		color: #312852;
	}
	.alert-vanco{
		background: #eae8f4;
		border-color: #d3cde7;
		color: #312852;
	}
	.sapphire-payment-portal .btn-vanco{	
		background: #312852;
		color: #FFF;
	}
</style>
